module.exports = __webpack_public_path__ + "img/Unknowns Icon_Over.2853c69f.svg";